import { Fancybox } from '@fancyapps/ui';

export default class Lightbox {

	constructor(element) {
		this.handleTriggerClick = this.handleTriggerClick.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.element = element;
		this.instance = undefined;
		this.itemIndexAttribute = 'data-lightbox-index';
		this.items = this.element ? this.element.querySelectorAll('a') : undefined;
	}

	getFileName(src) {
		const url = new URL(src);
		const pieces = url.pathname.split('/');
		return pieces[pieces.length - 1];
	}

	parseItems() {
		const items = [];
		if (this.items instanceof NodeList) {
			this.items.forEach(item => {
				if (item instanceof HTMLElement) {
					const thumbnail = item.querySelector('img.attachment-thumbnail');
					const fileName = this.getFileName(item.href);
					items.push({
						src: item.href,
						thumb: (thumbnail instanceof HTMLImageElement) ? thumbnail.src : undefined,
						downloadSrc: item.href,
						downloadFilename: fileName,
					});
				}
			});
		}
		return items;
	}

	handleTriggerClick(e) {
		e.preventDefault();
		const index = Number(e.currentTarget.getAttribute(this.itemIndexAttribute) || '0');
		this.open(index);
	}

	handleClose() {
		this.instance = undefined;
	}

	open(index = 0) {
		const items = this.parseItems();
		this.instance = new Fancybox(items, {
			idle: false,
			startIndex: index,
			Thumbs: false,
			Toolbar: {
				display: {
					left: ['infobar'],
					middle: [],
					right: ['slideshow', 'download', 'thumbs', 'fullscreen', 'close'],
				},
				items: {
					download: {
						tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><i class="material-icons">download</i></a>',
					},
					prev: {
						tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><i class="material-icons">arrow_back</i></button>',
					},
					next: {
						tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><i class="material-icons">arrow_forward</i></button>',
					},
					slideshow: {
						tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><i class="material-icons">play_circle</i></button>',
					},
					fullscreen: {
						tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><i class="material-icons">fullscreen</i></button>',
					},
					thumbs: {
						tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><i class="material-icons">view_carousel</i></button>',
					},
					close: {
						tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><i class="material-icons">cancel</i></button>',
					},
				}
			},
			on: {
				destroy: this.handleClose,
			},
		});
	}

	init() {
		if (this.items instanceof NodeList) {
			this.items.forEach((item, i) => {
				item.setAttribute(this.itemIndexAttribute, i.toString());
				item.addEventListener('click', this.handleTriggerClick);
			});
		}
	}

	destroy() {
		if (this.instance) {
			this.instance.close();
			this.instance.destroy();
			this.instance = undefined;
		}
		if (this.items instanceof NodeList) {
			this.items.forEach(item => {
				item.removeAttribute(this.itemIndexAttribute);
				item.removeEventListener('click', this.handleTriggerClick);
			});
		}
	}
}
